
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"attribute.anchor.title":"Detailseite öffnen"},"en":{"attribute.anchor.title":"Open detail page"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();